var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"group"},[_c('legend',{staticClass:"legend",class:{right: _vm.position == "right"}},[_vm._t("legend")],2),_vm._t("fields")],2)}
var staticRenderFns = []

export { render, staticRenderFns }